import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-center flex-column-fluid p-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "fw-bold mb-10",
  style: {"color":"#a3a3c7"}
}, " Phiên đăng nhập không hợp lệ hoặc đã hết hạn ", -1)
const _hoisted_3 = { class: "d-flex gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: "/sign-in",
        class: "btn btn-primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Đăng nhập lại ")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/trang-chu",
        class: "btn btn-light-primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Quay về trang chủ ")
        ]),
        _: 1
      })
    ])
  ]))
}